import { InputLabel } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
  color: theme.palette.custom.black[60],
  fontSize: '16px',
  fontWeight: 500,
  marginBottom: '11px',
  cursor: 'pointer',

  '&.Mui-error': {
    color: theme.palette.custom.black[60],
  },
}));
